<section class="mobile-app-cta-container">
  <div class="promo-image">
    <img
      class="responsive-img-cover"
      alt="Go Mobile"
      [ngSrc]="mobileAppPromoDefaultImg"
      [srcset]="mobileAppPromoImgSrcSet"
      i18n-alt
    />
  </div>
  <div class="app-download">
    <div class="helper-align-center">
      <h1 class="mat-h1" i18n>Go Mobile</h1>
      <p class="is-homepage call-to-action" i18n>
        Get RIDE COMMAND® on the go, even if you don't have the latest hardware on-board.
      </p>
      <p class="is-map call-to-action">
        <ng-container i18n>For the best experience viewing the map we recommend downloading the</ng-container>
        {{ brand }}
        <ng-container i18n>mobile app.</ng-container>
      </p>
      <div class="store-buttons-container">
        <div class="apple">
          <a id="appleStoreCTALink" rel="noreferrer" target="_blank" [href]="appStoreUrl">
            <img alt="Apple Store" ngSrc="/assets/images/apple-app-store.svg" i18n-alt />
          </a>
        </div>
        <div class="google">
          <a id="googlePlayStoreCTALink" rel="noreferrer" target="_blank" [href]="playStoreUrl">
            <img alt="Google Play" ngSrc="/assets/images/google-play-store.svg" i18n-alt />
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
